import React from 'react'
import { ROLES } from '../../model/roles';
import { useSelector } from 'react-redux';
import UtilityService from '../../services/UtillityServices/UtilityService';
import { Card, Row, Col } from 'react-bootstrap';


const Userinfo = ({userData}) => {
    const userLoggedIn = useSelector(state => state?.user?.userData);
    return (
        <>
           <div className='row'>
              <span className='fs-4 d-block'><i>Informazioni personali</i></span>
              {
                 (userData?.nome || userData?.cognome) && (
                  <div className='col-sm-12 col-md-6 my-3'>
                        <span className='small text-muted d-block'><b>Nome e cognome</b></span>
                        <span className='d-block'>{userData?.titolo} {userData?.nome} {userData?.cognome}</span>
                  </div>
                  )
              }
              {
                 (userData?.data_nascita && 
                  <div className='col-sm-12 col-md-6 my-3'>
                        <span className='small text-muted d-block'><b>Data di nascita</b></span>
                        <span className='d-block'>{UtilityService.formatDate(userData?.data_nascita)}</span>
                  </div>
                  )
              }
              { userData?.luogo_nascita && 
               ( 
               <div className='col-sm-12 col-md-6 my-3'>
                    <span className='small text-muted d-block'><b>Città di nascita</b></span>
                    <span className='d-block'>{userData?.luogo_nascita}</span>
              </div>
                )
              }
              {
                 userData?.provincia_nascita && (
                  <div className='col-sm-12 col-md-6 my-3'>
                        <span className='small text-muted d-block'><b>Provincia di nascita</b></span>
                        <span className='d-block'>{userData?.provincia_nascita}</span>
                  </div>
                  )
              }
              {
                 userData?.sesso && (
                  <div className='col-sm-12 col-md-6 my-3'>
                        <span className='small text-muted d-block'><b>Genere</b></span>
                        <span className='d-block'>{(userData.sesso === 'M' ? 'Maschio' : 'Femmina')}</span>
                  </div>
                  )
              }
              {
                 userData?.telefono1 && (
                  <div className='col-sm-12 col-md-6 my-3'>
                        <span className='small text-muted d-block'><b>Numero di telefono 1</b></span>
                        <span className='d-block'>{userData.telefono1}</span>
                  </div>
                  )
              }
              {
                 userData?.telefono2 && (
                  <div className='col-sm-12 col-md-6 my-3'>
                        <span className='small text-muted d-block'><b>Numero di telefono 2</b></span>
                        <span className='d-block'>{userData.telefono2}</span>
                  </div>
                  )
              }

<div className="mt-4">
    <h6 className="fw-bold">Documenti caricati</h6>
    <Row className="g-2 mt-2"> 
        {/* Colonna Documento Identità */}
        <Col xs={12} md={6}>
            <div className="mb-2"><strong>Documento Identità:</strong></div>
            <div className="d-flex flex-column gap-2"> 
                {userData?.path_documento ? (
                    <a href={userData.path_documento} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary d-inline-flex align-items-center">
                        <i className="bi bi-file-earmark-text me-2"></i> Visualizza Fronte
                    </a>
                ) : ( <span className="text-muted small"><i>Fronte non caricato</i></span> )}
                {userData?.path_documento_retro ? (
                    <a href={userData.path_documento_retro} target="_blank" rel="noopener noreferrer" 
                       className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"> {/* <-- MODIFICATO */}
                        <i className="bi bi-file-earmark-text me-2"></i> Visualizza Retro
                    </a>
                ) : ( <span className="text-muted small"><i>Retro non caricato</i></span> )}
            </div>
        </Col>

        {/* Colonna Codice Fiscale */}
        <Col xs={12} md={6}>
            <div className="mb-2"><strong>Codice Fiscale:</strong></div>
            <div className="d-flex flex-column gap-2"> 
                {userData?.path_codicefiscale ? (
                    <a href={userData.path_codicefiscale} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary d-inline-flex align-items-center">
                        <i className="bi bi-file-earmark-text me-2"></i> Visualizza Fronte
                    </a>
                ) : ( <span className="text-muted small"><i>Fronte non caricato</i></span> )}
                {userData?.path_codicefiscale_retro ? ( 
                    <a href={userData.path_codicefiscale_retro} target="_blank" rel="noopener noreferrer" 
                       className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"> {/* <-- MODIFICATO */}
                        <i className="bi bi-file-earmark-text me-2"></i> Visualizza Retro
                    </a>
                ) : ( <span className="text-muted small"><i>Retro non caricato</i></span> )}
            </div>
        </Col>
        
        {!userData?.path_documento && !userData?.path_documento_retro && !userData?.path_codicefiscale && !userData?.path_codicefiscale_retro && (
             <Col xs={12}><span className="text-muted small"><i>Nessun documento caricato.</i></span></Col>
        )}
    </Row>
</div>
            </div>
     
               {   
                  (userData?.tipo_utente === "corsista" && (userData?.fatturazione_nominativo || userData?.fatturazione_piva || userData?.fatturazione_indirizzo || userData?.fatturazione_cap || userData?.fatturazione_citta || userData?.fatturazione_provincia)) && (
                  <div className='row mt-5'>
                  <span className='fs-4 d-block'><i>Dati fatturazione</i></span>
                  {
                        userData?.fatturazione_nominativo && (
                        <div className='col-sm-12 col-md-6 my-3'>
                              <span className='small text-muted d-block'><b>Nominativo/Ragione sociale</b></span>
                              <span className='d-block'>{userData.fatturazione_nominativo}</span>
                        </div>
                        )
                  }
                  {
                        userData?.fatturazione_piva && (
                        <div className='col-sm-12 col-md-6 my-3'>
                              <span className='small text-muted d-block'><b>C.F./Partita iva</b></span>
                              <span className='d-block'>{userData.fatturazione_piva}</span>
                        </div>
                        )
                  }
                  {
                        (userData?.fatturazione_indirizzo || userData?.fatturazione_cap || userData?.fatturazione_citta || userData?.fatturazione_provincia) && (
                        <div className='col-sm-12 col-md-6 my-3'>
                              <span className='small text-muted d-block'><b>Indirizzo</b></span>
                              <span className='d-block'>{userData?.fatturazione_indirizzo}{userData?.fatturazione_cap ? ', ' : ''}{userData?.fatturazione_cap}{userData?.fatturazione_citta ? ', ' : ''}{userData?.fatturazione_citta}{userData?.fatturazione_provincia ? ', ' : ''}{userData?.fatturazione_provincia}</span>
                        </div>
                        )
                  }
                  </div>
                  )}

               {   (userData?.tipo_utente === "corsista" && (userData?.spedizione_nominativo || userData?.spedizione_indirizzo  || userData?.spedizione_indirizzo || userData?.spedizione_cap || userData?.spedizione_citta || userData?.spedizione_provincia)) && (
                   <div className='row mt-5'>
                     <span className='fs-4 d-block'><i>Dati spedizione</i></span>
                     {
                       userData?.spedizione_nominativo && (
                       <div className='col-sm-12 col-md-6 my-3'>
                             <span className='small text-muted d-block'><b>Nominativo</b></span>
                             <span className='d-block'>{userData?.spedizione_nominativo}</span>
                       </div>
                       )
                     }
                     {
                       (userData?.spedizione_indirizzo || userData?.spedizione_cap || userData?.spedizione_citta || userData?.spedizione_provincia) && (
                       <div className='col-sm-12 col-md-6 my-3'>
                       <span className='small text-muted d-block'><b>Indirizzo</b></span>
                       <span className='d-block'>{userData?.spedizione_indirizzo}{userData?.spedizione_cap ? ', ' : ''}{userData?.spedizione_cap}{userData?.spedizione_citta ? ', ' : ''}{userData?.spedizione_citta}{userData?.spedizione_provincia ? ', ' : ''}{userData?.spedizione_provincia}</span>
                     </div>
                       )
                     }
                     </div>
                   )}

                   {
                     (userLoggedIn?.tipo_utente === "admin" || userLoggedIn?.tipo_utente === "course_designer" || userLoggedIn?.tipo_utente === "developer")
                      && userData?.id_superpartner && (
                      <div className='row my-3'>
                        <span className='small text-muted d-block'><b>Superpartner</b></span>
                        <span className='d-block'>{userData?.superpartner_nome}</span>
                      </div>
                     )
                   }

        </>
      )
}

export default Userinfo;